import React, { useState } from "react";
import cssLogin from "../common.module.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomImageContainer from "../../../components/common/CustomImageContainer.jsx";
import SignUpImg from "../../../assets/forgotPassword.svg";
import Starfor from "../../../assets/StarForLogo.svg";
import Text from "../../../components/typography/Text/index.jsx";
import { MdEmail, MdLock } from "react-icons/md";
import Grid from "../../../components/layout/grid/Grid";
import CustomTextInput from "../../../components/common/CustomTextInput";
import CustomButton from "../../../components/common/CustomButton/CustomButton";

export default function ChangePassword() {
    const [email, setEmail] = useState("");

    const loginSchema = Yup.object().shape({
        
        newPassword: Yup.string().min(6, "Password must be at least 6 characters").required("Required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
            .required("Required"),
    });

    const OnSubmit = async (values, { setSubmitting }) => {
        const data = {
            email: values.email,
            newPassword: values.newPassword,
        };
        console.log("Password Reset Data:", data);
        // API call for password reset logic
    };

    return (
        <section className="w-full h-screen flex flex-1 bg-white">
            <div className="flex flex-row justify-between w-full">
                <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                    <div className={cssLogin.cardwidth}>
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8 flex flex-col  w-[100%]">
                            <div className="flex gap-6   ">
                                <div className="flex flex-col w-full ">
                                    <div className="flex items-center justify-center   h-full w-full mb-7">
                                        <CustomImageContainer src={Starfor} />
                                    </div>
                                    <div className="flex flex-col items-start justify-start ml-0">
                                    <Text variant="h3-title" className="mt-0 ml-0 !text-blue-900 ">
                                       Forgot Password?
                                    </Text>
                                    <p className="text-[#282828] text-base font-[700] mt-2 ">
                                        Please enter your new password.
                                    </p></div>
                                </div>
                            </div>
                            <div className="w-full">
                                <Formik
                                    initialValues={{
                                        
                                        newPassword: "",
                                        confirmPassword: "",
                                    }}
                                    validationSchema={loginSchema}
                                    onSubmit={OnSubmit}
                                >
                                    {({ isValid, isSubmitting }) => (
                                        <Form>
                                            <Grid xs={12} md={12}>
                                                
                                                <Grid item xs={12} md={12}>
                                                    <CustomTextInput
                                                        name="newPassword"
                                                        type="password"
                                                        label="New Password"
                                                        placeholder="Enter new password"
                                                        endIconBg={true}
                                                        endIcon={<MdLock />}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    <CustomTextInput
                                                        name="confirmPassword"
                                                        type="password"
                                                        label="Re-enter Password"
                                                        placeholder="Confirm new password"
                                                        endIconBg={true}
                                                        endIcon={<MdLock />}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <CustomButton
                                                        style={{ width: "100%" }}
                                                        label="Change Password"
                                                        size="md"
                                                        type="submit"
                                                        isLoading={isSubmitting}
                                                        disabled={!isValid || isSubmitting}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center mx-auto md:h-screen lg:py-0 bg-white w-full">
                    <CustomImageContainer src={SignUpImg} width={"70%"} height={"70%"} />
                </div>
            </div>
        </section>
    );
}
